module.exports = __webpack_public_path__ + "img/icon_take_away.ae4c98e3.svg";